import React from "react";
import SkeletonElement from "../../SkeletonElement";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SkeletonMyOrders = function SkeletonMyOrders() {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col shadow-xl px-4 py-6 w-[90%] h-[400px] lg:w-[75%] lg:h-[250px] ",
    children: [" ", /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col lg:flex-row mt-2",
      children: [" ", /*#__PURE__*/_jsxs("div", {
        className: "flex-shrink-0",
        children: [" ", /*#__PURE__*/_jsx(SkeletonElement, {
          type: "thumbnail",
          size: "h-36 w-36"
        }), " "]
      }), " ", /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col lg:px-4 flex-grow pt-3",
        children: [" ", /*#__PURE__*/_jsx(SkeletonElement, {
          type: "text"
        }), " ", /*#__PURE__*/_jsxs("div", {
          className: "mt-2",
          children: [" ", /*#__PURE__*/_jsx(SkeletonElement, {
            type: "title"
          }), " ", /*#__PURE__*/_jsxs("div", {
            className: "mt-6",
            children: [" ", /*#__PURE__*/_jsx(SkeletonElement, {
              type: "title"
            }), " "]
          }), " "]
        }), " "]
      }), " "]
    }), " "]
  });
};
export default SkeletonMyOrders;